import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper as MuiPaper, } from '@mui/material';
import { forwardRef } from 'react';
import { layout } from '../../styles/';
import { styled } from '../../utils';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
export const Paper = forwardRef(function Paper(props, ref) {
    const { children, error, helperText, ...otherProps } = props;
    return (_jsx(PaperStyled, { error: error, ref: ref, ...otherProps, children: _jsxs(_Fragment, { children: [_jsx("div", { children: children }), helperText ? (_jsxs(HelperTextContainerStyled, { error: error, children: [_jsx(Icon, { fontSize: "inherit", color: "inherit", variant: "alert-sign" }), _jsx(Typography, { variant: "inherit", component: "span", sx: {
                                marginLeft: (theme) => theme.spacing(1),
                            }, children: helperText })] })) : null] }) }));
});
const PaperStyled = styled(MuiPaper, {
    shouldForwardProp: (prop) => prop !== 'error',
})(({ theme, error }) => ({
    overflow: 'hidden',
    boxSizing: 'border-box',
    '& + .MuiPaper-root': {
        marginTop: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(3),
        },
        [theme.breakpoints.up('lg')]: {
            marginTop: theme.spacing(4),
        },
    },
    [theme.breakpoints.up('lg')]: {
        boxShadow: layout.shadow.s,
    },
    ...(error && {
        border: `2px solid ${theme.palette.error.main}`,
    }),
}));
const HelperTextContainerStyled = styled(MuiPaper, {
    shouldForwardProp: (prop) => prop !== 'error',
})(({ theme, error }) => ({
    borderTop: `2px solid ${theme.palette.secondary.main}`,
    fontSize: theme.typography.h6.fontSize,
    backgroundColor: theme.palette.secondary.contrastText,
    color: theme.palette.secondary.main,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'baseline',
    ...(error && {
        borderTopColor: theme.palette.error.main,
        backgroundColor: theme.palette.error.light,
        color: theme.palette.error.contrastText,
    }),
}));
